import { updateOrgRecommendedEpisodesRequest } from '@/requests';

import { postgrestApi } from '../postgrest-api';
import { PostgrestApiTags } from '../store.constants';

export const adminContentCurationApi = postgrestApi.injectEndpoints({
  endpoints: builder => ({
    updateOrgRecommendedEpisodes: builder.mutation<
      boolean,
      { episodes: { episodeId: string; position: number }[] }
    >({
      query: updateOrgRecommendedEpisodesRequest,
      invalidatesTags: [PostgrestApiTags.ORGANIZATION_PLAYLIST_EPISODES],
    }),
  }),
});

export const { useUpdateOrgRecommendedEpisodesMutation } =
  adminContentCurationApi;
